<template>
  <el-dialog
    :title="title"
    append-to-body
    destroy-on-close
    :visible.sync="visible"
    :close-on-click-modal="false"
    width="600px"
  >
    <div v-loading="loading" v-if="visible">
      <el-form ref="form" :model="form" :rules="rules" label-width="120px">
        <el-form-item label="用户名称" prop="name">
          {{ form.name }}
        </el-form-item>
        <el-form-item label="手机号" prop="name">
          {{ form.phone }}
        </el-form-item>
        <el-form-item label="角色权限" prop="rolePermissionId">
          <el-select
            clearable
            multiple
            style="width: 100%;"
            placeholder="请选择角色"
            v-model="form.rolePermissionIds"
          >
            <el-option
              v-for="item in roleList"
              :key="item.id"
              :label="item.roleName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" :loading="loadingSubmit" :disbaled="loadingSubmit" @click="submitForm">确 定</el-button>
      <el-button @click="close">取 消</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import { rolepermissionpanel, rolepermissionadmin, rolepermissionpage as getRoleList } from 'api/request'
  export default {
    data () {
      return {
        title: '设置用户权限',
        visible: false,
        loading: false,
        loadingSubmit: false,
        // 表单参数
        form: {
          id: undefined,
          rolePermissionIds: undefined,
          name: '',
        },
        // 表单校验
        rules: {
          rolePermissionIds: [
            {required: true, message: '请选择角色', trigger: 'blur'}
          ],
        },
        roleList: [],
        type: undefined
      }
    },
    watch: {
      visible (val) {
        if (!val) {
          Object.assign(this.$data, this.$options.data.call(this));
        }
      },
    },
    methods: {
      async show(data) {
        this.visible = true
        this.loading = true
        const { rolePermissions, type } = data
        this.form = data
        this.type = type
        const currentRolePermissionIds = rolePermissions && rolePermissions.map(v => v.id)
        await this.getAllRole(currentRolePermissionIds)
        this.loading = false
      },
      submitForm() {
        this.$refs['form'].validate((valid) => {
          if (valid) {
            let params = {
              id: this.form.id,
              rolePermissionIds: this.form.rolePermissionIds
            }
            this.loading = true
            this.loadingSubmit = true
            const API = this.type === 1 ? rolepermissionadmin : rolepermissionpanel
            API(params).then((res) => {
              if (res) {
                this.$message({ message: '操作成功', type: 'success' })
                this.$emit('done')
                this.close()
              }
              this.loading = false
              this.loadingSubmit = false
            }).finally(() => {
              this.loading = false
              this.loadingSubmit = false
            })
          }
        })
      },
      async getAllRole (currentRolePermissionIds) {
        const { rows } = await getRoleList({ pageIndex: 1, pageSize: 9999 })
        if (rows && Array.isArray(rows) && rows.length > 0) {
          this.roleList = rows
          if (currentRolePermissionIds) {
            this.form.rolePermissionIds = currentRolePermissionIds
          }
        }
      },
      /** 关闭弹窗 */
      close() {
        Object.assign(this.$data, this.$options.data.call(this))
      }
    }
  }
</script>

<style scoped lang="scss">

</style>
